module.exports = __webpack_public_path__ + "img/086-nigeria.9d003ecf.svg";